import React, { useCallback, useEffect, useState } from 'react';

import { FormTipoCursos } from '../../components/FormTipoCursos';
import { ErrorRetrievingData } from '../../components/ErrorRetrievingData';
import MenuMain from '../../MenuMain';

import { AppFooter } from '../../AppFooter';

import api from '../../api/api';

export default function EditarCursosPage(props) {

    const [tipoCursos, setTipoCursos] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [errorGettingCursos, setErrorGettingCursos] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');
    const [idTipoCursos] = useState(props.match.params.id)

    

    const getTipoCursos = async () => {
        try {
          const respTipo = await api.get(`tipo-cursos/${idTipoCursos}`);
    
          setTipoCursos(respTipo.data);

        } catch (error) {
          console.log('Erro ao buscar tipos de curso:', error);
        }
      };
    
      useEffect(() => {
        getTipoCursos();
      }, []);


    return (
        <>
            <MenuMain >
                {
                    errorGettingCursos ?
                        <ErrorRetrievingData
                            errorMessage={errorMessage}
                            retrieveFunction={() => getTipoCursos(idTipoCursos)}
                            isLoading={isLoading}
                        />
                        :
                        <FormTipoCursos
                            defaultValues={tipoCursos}                            
                            isEditing={true}
                            isLoading={isLoading}
                        />
                }
            </MenuMain>
            <AppFooter />
        </>
    );
}